import React, { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { store as mainStore } from '../../../../../store';
import { store } from './Commission';
import Button from '@material-ui/core/Button';
import green from '@material-ui/core/colors/lightGreen';
import red from '@material-ui/core/colors/red';
import axios from '../../../../../api/axios';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  percentRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
  success: {
    background: green[300],
  },
  danger: {
    background: red[300],
  },
}));

const CommissionForm = () => {
  const classes = useStyles();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { commission, error, isLoaded, page },
    dispatch,
    actions: { fetchingCommissions },
  } = useContext(store);
  const {
    _id: id,
    title,
    percentage,
    percentage2,
    // percentage3,
    description,
  } = commission;

  const handleChange = (e) => {
    let { name, value } = e.target;
    dispatch({ type: 'CHANGE_FIELD', payload: { name, value } });
  };
  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!title || (title && title.length < 3)) {
      er.title = 'عنوان ضریب بایستی حداقل ۳ حرف داشته باشد.';
    }
    if (!percentage || percentage > 99 || percentage < 0) {
      er.percentage = 'درصد الزامی';
    }
    if (!percentage2 || percentage2 > 99 || percentage2 < 0) {
      er.percentage2 = 'درصد الزامی';
    }
    // if (!percentage3 || percentage3 > 99 || percentage3 < 0) {
    //   er.percentage3 = 'درصد الزامی';
    // }

    // Validation patterns end here.
    if (isSingleValidation) {
      let err = {};

      for (const v in commission) {
        if (commission[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        dispatch({ type: 'ERROR', payload: err });
        return false;
      }
      {
        dispatch({ type: 'ERROR', payload: {} });
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        dispatch({ type: 'ERROR', payload: er });
        return false;
      }
      dispatch({ type: 'ERROR', payload: er });
      return true;
    }
  };
  const handleAdd = async () => {
    if (!validation()) {
      showError('خطاهای مشخص شده را برطرف نمائید.');
      return;
    }
    try {
      const {
        data: { messages },
      } = await axios.post(`/api/v1/admin/commissions/`, {
        title,
        percentage,
        percentage2,
        // percentage3,
        description,
      });
      showMessage(messages);
      const res = await fetchingCommissions(page, itemsCountPerPage);
      dispatch({ type: 'COMMISSIONS_WITH_RESET_FORM', payload: res });
    } catch (error) {
      showError(error);
    }
  };
  const handleCancel = () => {
    dispatch({ type: 'RESET_FORM' });
  };
  const handleEdit = async () => {
    if (!validation()) {
      showError('خطاهای مشخص شده را برطرف نمائید.');
      return;
    }
    try {
      const {
        data: { messages },
      } = await axios.put(`/api/v1/admin/commissions/${id}`, {
        title,
        percentage,
        percentage2,
        description,
      });
      showMessage(messages);
      const res = await fetchingCommissions(page, itemsCountPerPage);
      dispatch({ type: 'COMMISSIONS_WITH_RESET_FORM', payload: res });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <div className={classes.root}>
      <TextField
        name="title"
        variant="outlined"
        size="medium"
        fullWidth
        onChange={handleChange}
        label="نام ضریب مالی"
        value={title ? title : ''}
        onBlur={validation}
        error={error.title ? true : false}
        helperText={error.title ? error.title : ''}
      />
      <div className={classes.percentRow}>
        <TextField
          name="percentage"
          variant="outlined"
          size="medium"
          fullWidth
          onChange={handleChange}
          label="درصد‌کامل"
          type="number"
          value={percentage ? percentage : ''}
          onBlur={validation}
          error={error.percentage ? true : false}
          helperText={error.percentage ? error.percentage : ''}
        />
        <TextField
          name="percentage2"
          variant="outlined"
          size="medium"
          fullWidth
          onChange={handleChange}
          label="درصد پلیس‌راهی"
          type="number"
          value={percentage2 ? percentage2 : ''}
          onBlur={validation}
          error={error.percentage2 ? true : false}
          helperText={error.percentage2 ? error.percentage2 : ''}
        />
        {/* <TextField
          name="percentage3"
          variant="outlined"
          size="medium"
          fullWidth
          onChange={handleChange}
          label="درصد‌حواله"
          type="number"
          value={percentage3 ? percentage3 : ''}
          onBlur={validation}
          error={error.percentage3 ? true : false}
          helperText={error.percentage3 ? error.percentage3 : ''}
        /> */}
      </div>
      <TextField
        name="description"
        variant="outlined"
        size="medium"
        fullWidth
        onChange={handleChange}
        label="توضیحات"
        rows={3}
        multiline
        value={description ? description : ''}
      />
      <div className={classes.actions}>
        {commission && commission._id ? null : (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.success}
            onClick={handleAdd}
          >
            افزودن
          </Button>
        )}
        {commission && commission._id ? (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.success}
            onClick={handleEdit}
          >
            ویرایش
          </Button>
        ) : null}
        {commission && commission._id ? (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.danger}
            onClick={handleCancel}
          >
            صرفنظر
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(CommissionForm);
